export default __webpack_public_path__ + "static/media/rudlingTech2Low.eadd526a.jpg";